"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _chartStyles = require("./chartStyles");

var _YAxisArrow = _interopRequireDefault(require("./YAxisArrow"));

var _ShadowFilter = _interopRequireDefault(require("./ShadowFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-param-reassign */
var CustomerYAxis = function CustomerYAxis(_ref) {
  var handleTickFormat = _ref.handleTickFormat,
      hasNoData = _ref.hasNoData,
      roundedMaxValue = _ref.roundedMaxValue,
      tickValues = _ref.tickValues,
      yAxisLabel = _ref.yAxisLabel;
  return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    dontCheckIfEmpty: true,
    margin: {
      top: 60,
      bottom: 60
    },
    xType: "ordinal",
    width: 80,
    yDomain: [0, roundedMaxValue]
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.GradientDefs, null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement(_ShadowFilter["default"], null))), /*#__PURE__*/_react["default"].createElement(_reactVis.YAxis, {
    left: -80,
    style: _chartStyles.yAxisStyle,
    tickFormat: function tickFormat(t) {
      return /*#__PURE__*/_react["default"].createElement(_YAxisArrow["default"], null, handleTickFormat ? handleTickFormat(t) : "".concat(t, " kWh"));
    },
    tickValues: hasNoData ? [0] : tickValues,
    width: 80
  }), yAxisLabel && !hasNoData && /*#__PURE__*/_react["default"].createElement(_reactVis.ChartLabel, {
    xPercent: 0.42,
    text: yAxisLabel,
    className: "alt-y-axis-label"
  }));
};

CustomerYAxis.propTypes = {
  handleTickFormat: _propTypes["default"].func,
  hasNoData: _propTypes["default"].bool,
  roundedMaxValue: _propTypes["default"].number.isRequired,
  tickValues: _propTypes["default"].arrayOf(_propTypes["default"].number),
  yAxisLabel: _propTypes["default"].string
};
CustomerYAxis.defaultProps = {
  handleTickFormat: undefined,
  hasNoData: false,
  tickValues: [],
  yAxisLabel: null
};
var _default = CustomerYAxis;
exports["default"] = _default;